import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@iconify/react';
import { Box } from '@material-ui/core';
import { Formik } from 'formik';
import mdClose from '@iconify/icons-ion/md-close';
import clsx from 'clsx';
import * as Yup from 'yup';
import { MentionsInput, Mention } from 'react-mentions';
import moment from 'utils/moment';
import SectionHeader from '../sectionHeader';
import HeaderBack from '../headerBack';
import Panel from '../panel';
import Modal from '../modal';
import Button from '../button';
import Clickable from '../clickable/Clickable';
import CommentContainer from '../commenContainer';
import Collapsible from '../collapsible/Collapsible';
import AttachmentDetail from '../../modules/forms/components/AttachmentDetail';
import CustomFieldDetail from '../customFields/CustomFieldDetail';
import Attachments from '../../modules/forms/components/Attachments';
import Map from '../Map/Map';
import styles from '../DetailPageBuilder/detail.module.scss';
import badgeStyles from '../../modules/Badging/Detail/detail.module.scss';
import PulpoField from '../../pulpo_visualizer/fields';

const defaultStyle = {
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
    color: 'white'
  },

  '&multiLine': {
    control: {
      fontFamily: 'monospace',
      minHeight: 63,
      color: 'white'
    },
    highlighter: {
      padding: 9,
      border: '1px solid transparent',
      color: 'white'
    },
    input: {
      padding: 9,
      border: '1px solid grey',
      color: 'white'
    }
  },

  '&singleLine': {
    control: {
      fontFamily: 'lato',
      minHeight: 40,
      color: 'white'
    },

    highlighter: {
      padding: 9,
      border: '1px solid transparent',
      color: 'white'
    },
    input: {
      padding: 9,
      color: '#202020',
      border: '1px solid grey'
    }
  },

  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
      TextAlign: 'left'
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#cee4e5'
      }
    }
  }
};

const defaultMentionStyle = {
  color: '#3A61A8'
};

const DetailPage =({ sectionHeader, backRoute, logData, panelHeading, tableHeadders, icon, error, comments, handleCloseComment,
   forDefects, handleCompleted, handleAnswer, answer, handleCommentsModel, commentModal, commentCount, submitComment,
    adpComments, profile, callAppealApi, actionBtn, forViolations, checkAppealExpiry, changePermissions }) => {
    const ValidationRule = Yup.object().shape({
      description: Yup.string()
        .matches(/^(?!\s+$).*/, 'Description cannot be blank!')
        .required('This is required field!')
    });
    const [state, setState] = useState({
        ActionDropdown: false,
        delPopup: false,
        viewImg: false,
        imgUrl: ''
      });
    const [actionsShow, setActionsShow] = useState(false);
    const [appealModal, setAppealModal] = useState(false);
    const [appealMessage, setAppealMessage] = useState('');

    const handleAppealSubmit=() => {
      // it calls appeal api
      callAppealApi(appealMessage);
      setAppealModal(false);
      setActionsShow(false);
    };

    const sortCommentsAndAudit = (comment, audits) => [...audits, ...comment].sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

    const getRow = () => {
        const filteredHeaders = tableHeadders.filter((e) => {
          if (e[0]=== 'sub_type' && !logData[e[0]]) {
            return false;
          }
          return true;
        });
        let result = filteredHeaders.map((ele) => {
          if (ele[1] === 'comment') {
            return (
              <div className={styles.infoRow} style={{ width: '100%' }}>
                <span className={styles.title}>
                  <FormattedMessage
                    id=" "
                    defaultMessage={[ele[1]]}
                  />
                </span>
                <span className={styles.rowContent}>
                  {logData?.[ele[0]]}
                </span>
              </div>);
          }
          if (ele[0] === 'warning_only') {
            return (
              <div className={styles.infoRow} style={{ width: '100%' }}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="module.detail"
                    defaultMessage={[ele[1]]}
                  />
                </span>
                <span className={styles.rowContent}>
                  {logData?.[ele[0]]? 'Warning': 'Penalty'}
                </span>
              </div>);
          }
          if (ele[0] === 'avp_no' || ele[0] === 'badge_no') {
            return (
              <div className={styles.infoRow} style={{ width: '100%' }}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="module.detail"
                    defaultMessage={[ele[1]]}
                  />
                </span>
                <span className={styles.rowContent}>
                  {logData?.[ele[0]]|| logData?.vehicle_permit_details?.avp_no || logData?.permit_management_vehiclepermit?.avp_no
                  || logData?.permit_management_driverpermit?.badge_no || ''}
                </span>
              </div>);
          }
        if ((ele[0] === 'created_at' || ele[0] === 'violation_at' || ele[0] === 'defect_at')) {
            return <div className={styles.infoRow}>
            <span className={styles.title}>
              <FormattedMessage
                id=" "
                defaultMessage={[ele[1]]}
              />
            </span>
            <span className={styles.rowContent}>
              {moment(logData?.[ele[0]]).format(`${localStorage.getItem('dateFormat')} ${localStorage.getItem('timeFormat')}`)}
            </span>
                   </div>;
        }
        if (ele[0] === 'map' && logData?.info?.location) {
          return (
            <div style={{ width: '100%', gridRow: '1/span 7', gridColumnStart: '2' }}>
              <Map
                id={'2'}
                defaultLocation={logData.info.location}
              />
            </div>
          );
        } if (ele[0] === 'map') {
          return '';
        }
          return (
            <div className={styles.infoRow}>
              <span className={styles.title}>
                <FormattedMessage
                  id=" "
                  defaultMessage={[ele[1]]}
                />
              </span>
              <span className={styles.rowContent}>
                {ele[0] === 'logged_by' && (logData?.[ele[0]] || logData?.users_aerosimpleuser?.fullname)}
                {ele[0] !== 'logged_by' && logData?.[ele[0]]}
              </span>
            </div>);
        });
        return result;
      };

    return (
        <>
          <SectionHeader
            icon={icon}
            translationID={sectionHeader.id}
            defaultTitle={sectionHeader.default}
          >
          {actionBtn && logData?.settings?.tenant_appeal_process && changePermissions
           && <div className={styles.actionBtn} style={{ paddingRight: '26px' }}>
              <Clickable
                className={styles.actionsBtn}
                onClick={() => { setActionsShow(!actionsShow); }}
              >
                <FormattedMessage
                  id="workorders.detail.actionBtn"
                  defaultMessage="Actions"
                />
              </Clickable>
              {actionsShow && (
                <ul className={`${styles.actionpopup} ${actionsShow ? styles.open : ''}  ${styles.actionsHeight}`}
                  style={{ width: logData?.status === 4 ?'115px' : '184PX' }}
                >
                  {forViolations && logData.settings?.tenant_appeal_process
                   && < >
                    {(!logData.permit_management_violationappeal?.length>0
                    && checkAppealExpiry)
                      ? <li className={styles.item}>
                          <Clickable
                              onClick={() => {
                                setAppealModal(!appealModal);
                              }}
                            >
                              <FormattedMessage id={' '} defaultMessage={'Appeal'} />
                          </Clickable>
                        </li>
                      : <li style={{ opacity: '0.3', padding: '5px 0px 5px 10px' }}>
                            <FormattedMessage id={' '} defaultMessage={'Appeal Disabled'} />
                        </li>
                      }
                      </>
                    }
                </ul>
                )}
              </div>
            }
          </SectionHeader>
          <HeaderBack
            translationID="workorder.settings.back"
            translationDefault="Back"
            backRoute={backRoute}
          />
          <div className={`container ${styles.container}`}>
           {!error && (
           <Panel
              containerClasses={styles.mainPanelviolation}
              title={panelHeading.id}
              defaultTitle={panelHeading.default}
              handleComments={handleCommentsModel}
              adpComments={adpComments}
              commentCount={commentCount}
            >
              <>
                <div className={styles.panelContent}>
                  <div className={styles.sectionHeader}>
                    <FormattedMessage
                      id="todo.table.Details"
                      defaultMessage="Details"
                    />
                  </div>
                  <div className={styles.requestInfo} style={{ width: '1000px' }}>
                    <div className={styles.infoTable}>
                      {logData && getRow()}
                      {logData?.response
                          && <div style={{ display: 'grid', gridTemplateColumns: '200%' }}>
                                <CustomFieldDetail
                                  data={logData.response}
                                  version={logData?.schema}
                                  fields={logData?.schema?.schema?.fields || []}
                                />
                             </div>
                      }
                      <div className={styles.infoRow} style={{
                        width: '100%',
                        display: 'block',
                        height: 'auto',
                        gridColumnStart: '1',
                        gridColumnEnd: '3'
                      }}>
                        <div className={styles.title}>
                          <FormattedMessage
                            id="sms.form.description"
                            defaultMessage="Description"
                          />
                        </div>
                        <div className={styles.rowContent} style={{ textAlign: 'left', wordWrap: 'break-word' }}>
                          {logData?.violation_details || logData?.description}
                        </div>
                      </div>
                      {forDefects && logData?.latest_comment
                    && <div className={styles.infoRow} style={{
                        width: '100%',
                        display: 'block',
                        height: 'auto',
                        gridColumnStart: '1',
                        gridColumnEnd: '3'
                      }}>
                        <div className={styles.title}>
                        <FormattedMessage
                          id=" "
                          defaultMessage="Latest Comment"
                        />
                        </div>
                        <div className={styles.rowContent} style={{ textAlign: 'left', wordWrap: 'break-word' }}>
                          {logData?.latest_comment}
                        </div>
                       </div>
                      }
                      {forViolations && logData?.settings?.tenant_appeal_process
                      && logData?.permit_management_violationappeal?.length>0
                        && <>
                        <div className={styles.infoRow} style={{
                          width: '100%',
                          display: 'block',
                          height: 'auto',
                          gridColumnStart: '1',
                          gridColumnEnd: '3'
                        }}>
                          <div className={styles.title}>
                            <FormattedMessage
                              id=" "
                              defaultMessage="Appeal Request"
                            />
                          </div>
                          <div className={styles.rowContent} style={{ textAlign: 'left', wordWrap: 'break-word' }}>
                            {logData.permit_management_violationappeal[0].description}
                          </div>
                        </div>
                        {logData.permit_management_violationappeal[0].reviewer_description
                        &&<div className={styles.infoRow} style={{
                          width: '100%',
                          display: 'block',
                          height: 'auto',
                          gridColumnStart: '1',
                          gridColumnEnd: '3'
                        }}>
                          <div className={styles.title}>
                            <FormattedMessage
                              id=" "
                              defaultMessage="Appeal Response"
                            />
                          </div>
                          <div className={styles.rowContent} style={{ textAlign: 'left', wordWrap: 'break-word' }}>
                            {logData.permit_management_violationappeal[0].reviewer_description}
                          </div>
                          </div>
                          }
                           </>
                      }
                      {logData?.maintenance_review?.attachments?.length > 0
                      && <div className={styles.infoRow} style={{
                          width: '100%',
                          display: 'block',
                          height: 'auto',
                          gridColumnStart: '1',
                          gridColumnEnd: '3'
                        }}>
                          <div className={styles.title}>
                            <FormattedMessage
                              id=" "
                              defaultMessage="Maintenance Attachments"
                            />
                          </div>
                          <div style={{ width: '950px', overflow: 'scroll hidden', border: 'none' }}>
                            <AttachmentDetail
                              attachments={logData?.maintenance_review?.attachments}
                              noBorder
                            />
                          </div>
                         </div>}
                    </div>
                  </div>
                  {logData?.attachments?.length > 0 && (
                  <Collapsible
                    title="Attachments"
                    styleClasses={styles.collapsibleHeader}
                    offset={400}
                    openOnMount
                    collapsibleHeight={0}
                  >
                      <div className={styles.photos}>
                        {logData.attachments.map(e => (
                          <div key={e.name} className={styles.wrapper}>
                            {((e.url && e.url.length > 0)
                              || (e.preview && e.preview.length > 0)) && (
                                <>
                                  {(e.type || e.content_type).includes('image') ? (
                                    <span role="button" tabIndex={0}
                                    onClick={() => { setState({ ...state, imgUrl: (e.preview || e.url), viewImg: true }); }}
                                    onKeyPress={() => { setState({ ...state, imgUrl: (e.preview || e.url), viewImg: true }); }}>
                                      <img
                                        src={e.preview || e.url}
                                        alt={e.name || e.file_name}
                                        style={{ paddingLeft: 0, cursor: 'pointer' }}
                                      />
                                    </span>
                                  ) : (
                                    <p>{e.name || e.file_name}</p>
                                  )}
                                </>
                              )}
                          </div>
                        ))}
                      </div>
                  </Collapsible>
                  )}
              {(logData?.status==='open' || logData?.status === 'rejected') && forDefects
              && <>
              <div style={{ marginTop: '20px' }}>
                <PulpoField
                key="maintenance_description"
                id="maintenance_description"
                type="string"
                isRequired={false}
                translationID=" "
                title="Comments On Defect Resolution (If Any)"
                widget={{ type: 'textarea' }}
                handleValueChange={a => handleAnswer({ ...answer, maintenance_description: a })}
                answer={answer.maintenance_description}
                handleFieldErrorChanged={() => ({})}
                style={{ fontSize: '16px' }}
                className={styles.defaultFontSize}
                />
                <Attachments
                  title="Maintenance Attachments"
                  id="attachments"
                  required={false}
                  handleAnswerChanged={(a) => { handleAnswer({ ...answer, attachments: a }); }}
                  attachments={answer.attachments}
                  handleFieldErrorChanged={() => {}}
                />
              </div>
              {profile?.permissions?.vehicle_permit?.includes('change_vehiclepermit')
                && <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <div className={styles.btnContainer}>
                      <Button onClick={() => handleCompleted()}
                      translationID={'quizSubmit'}
                      defaultText="Submit" action="primary" />
                    </div>
                   </div>
              }
                 </>}
                </div>
              </>
           </Panel>)
            }
            {
            error && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '450px' }}>
                    <h2>No Data Found</h2>
                </div>
            )
            }
          </div>
          <Modal showIn={state.viewImg} onClose={() => { setState({ ...state, viewImg: false }); }}>
            <div style={{ height: '500px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={state.imgUrl} alt="img" style={{ width: '90%', height: '90%' }} />
            </div>
          </Modal>
          <div className={styles.modalContent}>
            <Modal
              onClose={() => handleCloseComment()}
              showIn={commentModal}
              width="60%"
              minHeight="50%"
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                className={styles.headerBox}
              >
                <div className={styles.commentsHeader}>
                  <div className={styles.title}>
                    <FormattedMessage
                      id="adp.comments.header"
                      defaultMessage={'Comments'}
                      values={{ id: 27 }}
                    />
                  </div>
                </div>
                <div className={styles.iconGroup}>
                  <Icon
                    icon={mdClose}
                    onClick={() => {
                      handleCloseComment();
                    }}
                    height="20"
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </Box>
              <div className={styles.commentsBody}>
                <div className={styles.comments}>
                  {comments?.comments && comments?.audit_logs
                  && <CommentContainer
                      comments={sortCommentsAndAudit(comments?.comments, comments?.audit_logs)}
                      driverPermit
                    />}
                </div>
              </div>
              <div className={styles.commentsFooter}>
                <Formik
                  initialValues={{
                    description: '',
                    photos: []
                  }}
                  validationSchema={ValidationRule}
                  onSubmit={(values, formik) => {
                    const data = { comment: values.description, attachments: values.photos };
                    submitComment(data);
                    formik.resetForm();
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className={styles.textareaContainer}>
                        <MentionsInput
                          singleLine
                          value={values.description}
                          onChange={handleChange('description')}
                          handleBlur={handleBlur}
                          className={clsx(styles.commentInput, {
                            [styles.required]:
                              errors.description && touched.description
                          })}
                          classNames={styles}
                          placeholder="Leave a comment..."
                          allowSuggestionsAboveCursor
                          style={defaultStyle}
                        >
                          <Mention
                            data={[]}
                            style={defaultMentionStyle}
                            displayTransform={display => `@${display}`}
                          />
                        </MentionsInput>
                      </div>
                      {profile?.permissions?.vehicle_permit?.includes('change_vehiclepermit')
                        && <Box display="flex" justifyContent="flex-end">
                          <div className={styles.modalBtnGroup}>
                            <Button
                              onClick={() => { handleCommentsModel(); }}
                              translationID="inspections.new.cancel"
                              defaultText="Cancel  "
                              action="teritiary"
                            />
                            <Button
                              onClick={() => { handleSubmit(); }}
                              type="submit"
                              translationID="confirm.comment"
                              defaultText="Comment"
                              action="secondary"
                            />
                          </div>
                           </Box>
                      }
                    </form>
                  )}
                </Formik>
              </div>
            </Modal>
          </div>
          <Modal
            showIn={appealModal}
            onClose={() => setAppealModal(false)}
            width="500px"
            minHeight="150px"
            centered
          >
            <div className={badgeStyles.newTask}>
              <div
                className={badgeStyles.closeicon}
                style={{ padding: '15px 15px 0px 15px' }}
              >
                <FormattedMessage
                  tagName="p"
                  id=" "
                  defaultMessage="Appeal Request"
                />
                <Clickable onClick={() => setAppealModal(false)}>
                  <div style={{ cursor: 'pointer' }}>X</div>
                </Clickable>
              </div>
              <div className={badgeStyles.subHeading} style={{ fontWeight: '500' }}>
                <PulpoField
                  key="appealMsg"
                  id="appealMsg"
                  type="string"
                  isRequired
                  translationID="appeal_msg"
                  title="Kindly enter a reason for the appeal"
                  widget={{ type: 'textarea' }}
                  handleValueChange={a => setAppealMessage(a)}
                  answer={''}
                  handleFieldErrorChanged={() => ({})}
                  style={{ fontSize: '16px' }}
                  className={styles.defaultFontSize}
                />
              </div>
              <div
                className={badgeStyles.notefooter}
                style={{ justifyContent: 'flexEnd', gap: '3%' }}
              >
                <Button
                  action="teritory"
                  onClick={() => setAppealModal(false)}
                  translationID="todo.newTask.cancel"
                  defaultText="Cancel"
                />
                <div className={badgeStyles.saveWrapper1}>
                  <Button
                    onClick={() => handleAppealSubmit()}
                    translationID="adp.application.revoke.submit"
                    defaultText="Submit"
                    action="secondary"
                    disabled={appealMessage.length === 0}
                  />
                </div>
              </div>
            </div>
          </Modal>
        </>
      );
};

export default DetailPage;
